import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  select,
} from "../../lib";

import {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doPROJECT_DATA_DIGEST_SET,
  doADHERENCE_UPDATE,
  doPENDING_REQUEST_DELETE,
  doREQUEST_SKIP,
} from "../state";
import { checkRequestPending } from "./check_pending_request";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_DATA_DIGEST = "REQUEST_PROJECT_DATA_DIGEST";
export const doREQUEST_PROJECT_DATA_DIGEST = createDoRequestAction(REQUEST_PROJECT_DATA_DIGEST);

export const requestProjectDataDigestActionCreators = {
  doREQUEST_PROJECT_DATA_DIGEST,
};

export function* requestProjectDataDigest({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestProjectDataDigest");

  const sameRequestPending = yield call(checkRequestPending, REQUEST_PROJECT_DATA_DIGEST, payload);
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_PROJECT_DATA_DIGEST,
        requestId: payload.requestId,
      }),
    );
  }

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        yymmIndexList: v.array().items(v.number()),
        requestTaskData: v.bool(),
        requestScheduleTaskData: v.bool(),
        requestGarminData: v.bool(),
        requestDexcomData: v.bool(),
        garminTaskId: v.string().optional(),
      }),
    });
  } catch (error) {
    yield put(
      doPENDING_REQUEST_DELETE({
        requestType: REQUEST_PROJECT_DATA_DIGEST,
        requestId: payload.requestId,
      }),
    );

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DIGEST,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const {
    projectId,
    yymmIndexList,
    requestTaskData,
    requestScheduleTaskData,
    requestGarminData,
    requestDexcomData,
    garminTaskId,
  } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v2/web/project-data-digest`,
    accessToken,
    data: {
      projectId,
      yymmIndexList,
      requestTaskData,
      requestScheduleTaskData,
      requestGarminData,
      requestDexcomData,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    yield put(
      doPENDING_REQUEST_DELETE({
        requestType: REQUEST_PROJECT_DATA_DIGEST,
        requestId: payload.requestId,
      }),
    );
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DIGEST,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v2/web/project-data-digest",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  // console.log('project data digest', result.payload)

  yield put(
    doPROJECT_DATA_DIGEST_SET({
      ...result.payload,
    }),
  );

  const projectDataDigestState = yield select((state) => state?.projectDataDigest);
  const projectDataDigestSerializable = projectDataDigestState?.[projectId];

  yield put(
    doADHERENCE_UPDATE({
      projectDataDigest: projectDataDigestSerializable,
      inputProjectDataDigest: result.payload.projectDataDigest,
      garminTaskId,
    }),
  );

  yield put(
    doPENDING_REQUEST_DELETE({
      requestType: REQUEST_PROJECT_DATA_DIGEST,
      requestId: payload.requestId,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_DATA_DIGEST,
        fromPayload: payload,
        requestId: payload.requestId,
        url: "/v2/web/project-data-digest",
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectDataDigestSaga() {
  yield takeEvery(REQUEST_PROJECT_DATA_DIGEST, requestProjectDataDigest);
}
